/** @format */
import React from 'react';

import appMockupImage from '../../../images/img/app_mockup.jpg';
import logoImage from '../../../images/img/app_icon.jpg';
import { touchSize } from '../../utils/rwd';
import { useModal } from '../../modules/ui';

export const UseApp = () => {
	const { useAppModal, boundToggleUseAppModal } = useModal();
	if (!useAppModal) {
		return null;
	}

	return (
		<div className="modal is-active" style={{ position: 'fixed' }}>
			<div className="modal-background"></div>
			<div className="modal-card">
				<header
					className="modal-card-head"
					style={{ background: 'white', border: 0 }}>
					<p className="modal-card-title"></p>
					<button
						className="delete"
						aria-label="close"
						onClick={boundToggleUseAppModal}></button>
				</header>
				<section className="modal-card-body" style={{ padding: 0 }}>
					<div
						className="is-flex is-mobile is-multiline has-text-centered"
						style={{ height: '460px' }}>
						<img
							className="column is-4 is-hidden-touch"
							src={appMockupImage}
							alt="app"
						/>
						<div
							style={{
								maxWidth: '240px',
								marginLeft: window.innerWidth < touchSize ? 'auto' : '50px',
								marginRight: window.innerWidth < touchSize ? 'auto' : ''
							}}>
							<img
								src={logoImage}
								alt=""
								style={{ width: 80, marginTop: 10 }}
							/>
							<h1 className="title is-1 has-text-weight-bold">App下載</h1>
							<br />
							<a
								href="https://goo.gl/MPdHNW"
								style={{ color: '#0076ff', textDecoration: 'underline' }}>
								iOS
							</a>
							<a
								style={{ color: '#0076ff', textDecoration: 'underline' }}
								href="https://goo.gl/tmZ59c">
								| Android
							</a>
							<br />
							<span>下載Eatgether App以啟用完整功能，並且完全免費：</span>
							<br />
							<ul>
								<li className="has-text-weigh-bold">﹒建立＆報名聚會功能</li>
								<li className="has-text-weigh-bold">﹒追蹤＆新增好友功能 </li>
								<li className="has-text-weigh-bold">
									﹒聚會聊天室與一對一聊天
								</li>
								<li className="has-text-weigh-bold">﹒每日登入領取免費酒杯</li>
							</ul>
							<br />
							<span style={{ color: '#ca9c1d', fontSize: 13 }}>
								你也可以選擇訂閱進階服務，獲得更多強大的會員功能，詳細方案內容請參閱
								App 內「會員中心」頁面。
							</span>
						</div>
					</div>
				</section>
				<footer
					className="modal-card-foot"
					style={{ background: 'white', border: 0 }}></footer>
			</div>
		</div>
	);
};

export const ExtraMeetup = () => {
	const { extraMeetupModal, boundToggleExtraMeetupModal } = useModal();
	if (!extraMeetupModal) {
		return null;
	}

	return (
		<div className="modal is-active" style={{ position: 'fixed' }}>
			<div className="modal-background"></div>
			<div className="modal-card">
				<header
					className="modal-card-head"
					style={{ background: 'white', border: 0 }}>
					<p className="modal-card-title"></p>
					<button
						className="delete"
						aria-label="close"
						onClick={boundToggleExtraMeetupModal}></button>
				</header>
				<section className="modal-card-body" style={{ padding: 0 }}>
					<div
						className="is-flex is-mobile is-multiline has-text-centered"
						style={{ height: '460px' }}>
						<img
							className="column is-4 is-hidden-touch"
							src={appMockupImage}
							alt="app"
						/>
						<div
							style={{
								maxWidth: '240px',
								marginLeft: window.innerWidth < touchSize ? 'auto' : '50px',
								marginRight: window.innerWidth < touchSize ? 'auto' : ''
							}}>
							<img
								src={logoImage}
								alt=""
								style={{ width: 80, marginTop: 10 }}
							/>
							<h1 className="title is-1 has-text-weight-bold">Oops!</h1>
							<br />
							<a
								href="https://goo.gl/MPdHNW"
								style={{ color: '#0076ff', textDecoration: 'underline' }}>
								iOS
							</a>
							<a
								style={{ color: '#0076ff', textDecoration: 'underline' }}
								href="https://goo.gl/tmZ59c">
								| Android
							</a>
							<br />
							<span>聚會額度已滿，請下載APP版本，使用完整功能</span>
							<br />
							<br />
							<span style={{ color: '#ca9c1d', fontSize: 13 }}>
								你也可以選擇訂閱進階服務，獲得更多強大的會員功能，詳細方案內容請參閱
								App 內「會員中心」頁面。
							</span>
						</div>
					</div>
				</section>
				<footer
					className="modal-card-foot"
					style={{ background: 'white', border: 0 }}></footer>
			</div>
		</div>
	);
};
